export const types = {
	login: "[AUTH] Login",
	logout: "[AUTH] Logout",

	uiSetError: "[UI] setError",
	uiRemoveError: "[UI] removeError",

	uiStartLoading: "[UI] Start Loading",
	uiFinishLoading: "[UI] Finish Loading",

	notesAddNew: "[Notes] New note",
	notesActive: "[Notes] Set active note",
	notesLoad: "[Notes] Load notes",
	notesAddNewNote: "[Notes] Add new Note",
	notesUpdated: "[Notes] Updated note",
	notesFileUrl: "[Notes] Update image url",
	notesDelete: "[Notes] Delete note",
	notesLogoutCleaning: "[Notes] Logout Cleaning",
};
